// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../../graphql/api/index';

import * as Urql from '@/graphql/urql.ts';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const StoreMarketingDataDocument = `
    mutation storeMarketingData($input: StoreMarketingDataInput!, $referrer: Uri, $location: Uri!) {
  storeMarketingData(input: $input, referrer: $referrer, location: $location) {
    success
    customer {
      id
    }
  }
}
    `;

export function useStoreMarketingDataMutation() {
  return Urql.useMutation<SchemaTypes.StoreMarketingDataMutation, SchemaTypes.StoreMarketingDataMutationVariables>(StoreMarketingDataDocument);
};